export default "__VITE_ASSET__hTjSi2N3__"